module.exports = __webpack_public_path__ + "fonts/Zen_Maru_Gothic-400-[54]175.3579c13.woff2";